/* WEB-07 (25-oct-2026) · Ficha de producto en el celular, aprobada por Alan.
   Reacomoda la ficha que ya existe (no toca main-product.liquid ni product.json, pasan los 116 kB).
   decorate() corre en cada cambio de la página: solo mueve un bloque si no está en su lugar
   y solo cambia un texto si es distinto, así no entra en bucle. */
(() => {
  const mq = window.matchMedia('(max-width: 767px)');
  const dk = window.matchMedia('(min-width: 1024px)');
  const D = window.w7Pdp || {};
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => [...(r || document).querySelectorAll(s)];
  const txt = (el) => (el ? el.textContent.replace(/\s+/g, ' ').trim() : '');
  const setHtml = (el, h) => { if (el.innerHTML !== h) el.innerHTML = h; };
  const setTxt = (el, t) => { if (el.textContent !== t) el.textContent = t; };
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  // Pone `el` justo después de `ref` (o antes, con antes=true) si no está ahí
  const place = (el, ref, antes) => {
    if (!ref || !ref.parentNode) return;
    if (antes) { if (ref.previousElementSibling !== el) ref.parentNode.insertBefore(el, ref); }
    else if (ref.nextElementSibling !== el) ref.parentNode.insertBefore(el, ref.nextSibling);
  };
  const mk = (id, tag, cls, html) => {
    let el = document.getElementById(id);
    if (!el) { el = document.createElement(tag); el.id = id; el.className = cls; if (html != null) el.innerHTML = html; if (tag === 'button') el.type = 'button'; }
    return el;
  };
  const fs = (slug) => $(`variant-picker fieldset[data-option-slug="${slug}"]`);
  let ACC = null;
  const elegido = (f) => { const i = f && $('input:checked', f); return i ? i.value : ''; };

  // 1a · Foto plana del color elegido como 2.ª foto (el theme la tenía escondida). Se busca la foto
  //      de la variante con el mismo archivo que la muestra del color elegido.
  function plana() {
    const s = $('[id^="SliderGallery"]');
    const lab = $('fieldset[data-option-slug="color"] input:checked + label');
    if (!s) return;
    if (!lab) {
      // 26-oct · Sin opción Color (jeans): las planas son las fotos cuyo archivo dice «FotoPlana». La 1.ª de la galería es
      //          la delantera y las demás la trasera (el número del archivo no sirve: en el Pale Blue el «1» es la espalda)
      const vistas = {};
      $$('[id^="SliderGallery"] .product__media, [id^="SliderThumbnails"] .product__thumbnail').forEach((m) => {
        const i = $('img', m);
        const n = ((i && ((i.getAttribute('src') || '') + (i.getAttribute('srcset') || ''))) || '').toLowerCase();
        const on = n.includes('fotoplana');
        const k = m.classList.contains('product__media') ? 'g' : 't';
        const atras = on && !!vistas[k];
        if (on) vistas[k] = true;
        if (m.classList.contains('w7-plana') !== on) m.classList.toggle('w7-plana', on);
        if (m.classList.contains('w7-plana2') !== atras) m.classList.toggle('w7-plana2', atras);
        if (on && m.classList.contains('product__media')) { const tag = 'Foto plana · ' + (atras ? 'espalda' : 'frente'); if (m.dataset.w7tag !== tag) m.dataset.w7tag = tag; }
      });
      return;
    }
    const fn = ((lab.getAttribute('style') || '').match(/files\/([^?)"']+)/) || [])[1];
    const hit = fn && $$('.product__media--variant', s).find((m) => { const i = $('img', m); return i && ((i.getAttribute('src') || '') + (i.getAttribute('srcset') || '')).includes(fn); });
    const id = hit ? hit.dataset.mediaId : '';
    $$('.product__media--variant, .product__thumbnail.product__media--variant').forEach((m) => {
      const on = !!id && m.dataset.mediaId === id;
      if (m.classList.contains('w7-plana') !== on) m.classList.toggle('w7-plana', on);
    });
    if (hit) { const tag = 'Foto plana · ' + ($('fieldset[data-option-slug="color"] input:checked').value || ''); if (hit.dataset.w7tag !== tag) hit.dataset.w7tag = tag; }
  }

  // 1c · 26-oct (Alan): descripción del producto, 1.ª dentro de «Detalles» (sin el «Descripción y Calce:» del principio)
  function desc() {
    const src = document.getElementById('w7-desc-src');
    const it = $$('.pdp5-item').find((i) => /detalles/i.test(txt($('.pdp5-trigger', i))));
    const inner = it && $('.pdp5-inner', it);
    if (!src || !inner || $('.pdp5-pack-intro', inner)) return;
    let d = document.getElementById('w7-desc');
    if (!d) {
      d = document.createElement('div'); d.id = 'w7-desc'; d.className = 'w7-desc';
      d.appendChild(src.content.cloneNode(true));
      const w = document.createTreeWalker(d, NodeFilter.SHOW_TEXT);
      let n; while ((n = w.nextNode())) { if (n.nodeValue.trim()) { n.nodeValue = n.nodeValue.replace(/^\s*Descripci[oó]n( y [Cc]alce)?\s*:\s*/, ''); break; } }
    }
    if (inner.firstElementChild !== d) inner.insertBefore(d, inner.firstChild);
    const tw = document.createTreeWalker($('.pdp5-trigger', it), NodeFilter.SHOW_TEXT);
    let t; while ((t = tw.nextNode())) { if (/^\s*Composici[oó]n y materiales\s*$/.test(t.nodeValue)) t.nodeValue = 'Descripción, calce y tela'; }
  }

  // 1 · Fotos: contador «1 / N · deslizá»
  function galeria() {
    const s = $('[id^="SliderGallery"]');
    if (!s) return;
    const slides = $$('.product__media', s).filter((m) => m.offsetWidth > 0).sort((a, b) => a.offsetLeft - b.offsetLeft);
    if (slides.length < 2) return;
    const c = mk('w7-cnt', 'div', 'w7-cnt');
    place(c, s.parentNode);
    const paso = (slides[1].offsetLeft - slides[0].offsetLeft) || slides[0].offsetWidth;
    const n = Math.max(1, Math.min(slides.length, Math.round(s.scrollLeft / paso) + 1));
    setTxt(c, `${n} / ${slides.length}` + (n === 1 && !dk.matches ? ' · deslizá →' : ''));
    if (!s.dataset.w7cnt) { s.dataset.w7cnt = 1; s.addEventListener('scroll', () => requestAnimationFrame(galeria), { passive: true }); }
    if (dk.matches) flechas(s, slides, n, paso);
  }
  // Compu: flechas sobre la foto, miniaturas al costado marcan la foto que se ve
  function flechas(s, slides, n, paso) {
    const box = s.parentNode;
    ['prev', 'next'].forEach((k) => {
      const b = mk('w7-nav-' + k, 'button', 'w7-nav w7-nav--' + k, k === 'prev' ? '‹' : '›');
      if (!b.dataset.on) {
        b.dataset.on = 1;
        b.setAttribute('aria-label', k === 'prev' ? 'Foto anterior' : 'Foto siguiente');
        b.addEventListener('click', () => { const g = $('[id^="SliderGallery"]'); g.scrollBy({ left: (k === 'prev' ? -1 : 1) * g.clientWidth, behavior: 'smooth' }); });
      }
      if (b.parentNode !== box) box.appendChild(b);
      const dis = k === 'prev' ? n <= 1 : n >= slides.length;
      if (b.disabled !== dis) b.disabled = dis;
    });
    const cur = slides[n - 1] && slides[n - 1].dataset.mediaId;
    $$('[id^="SliderThumbnails"] .product__thumbnail').forEach((t) => {
      const v = String(t.dataset.mediaId === cur);
      if (t.getAttribute('aria-current') !== v) t.setAttribute('aria-current', v);
      if (!t.dataset.w7) {
        t.dataset.w7 = 1;
        t.addEventListener('click', () => {
          const g = $('[id^="SliderGallery"]');
          const m = g && $$('.product__media', g).find((x) => x.dataset.mediaId === t.dataset.mediaId && x.offsetWidth > 0);
          if (m) g.scrollTo({ left: m.offsetLeft - g.firstElementChild.offsetLeft, behavior: 'smooth' });
        });
      }
    });
  }

  // El theme lleva la foto elegida al borde exacto (sin el aire de 20 px): se corrige
  function aire() {
    const s = $('[id^="SliderGallery"]');
    if (!s) return;
    const sl = $$('.product__media', s).find((m) => m.offsetWidth > 0 && Math.abs(m.offsetLeft - s.scrollLeft) < 2);
    if (sl && s.scrollLeft > 0) s.scrollTo({ left: Math.max(0, sl.offsetLeft - 20), behavior: 'instant' });
  }

  // 2 · Nombre + estrellas + «728 la compraron este mes»
  function social() {
    const t = $('product-info .product__title');
    const b = $('#dlvr-sn-social b');
    const el = mk('w7-soc', 'div', 'w7-soc');
    // 26-oct: apagado hasta que el número se recalcule solo (era de pedidos 10-sep→9-oct: «este mes» no era cierto)
    if (!D.social || !t || !b || !/\d/.test(txt(b))) { if (el.isConnected) el.remove(); return; }
    setTxt(el, `🔥 ${txt(b)} la compraron este mes`);
    if (el.parentNode !== t) t.appendChild(el);
  }

  // 3 · Precio tocable → «Cómo pagar con transferencia»
  function precio() {
    const strip = $('product-info .dlvr-price-strip');
    const box = strip && strip.closest('.rte');
    if (!box || box.dataset.w7pr) return;
    box.dataset.w7pr = 1;
    box.classList.add('w7-pr-tap');
    box.setAttribute('role', 'button');
    box.setAttribute('tabindex', '0');
    box.setAttribute('aria-expanded', 'false');
    const abrir = () => {
      const p = mk('w7-pago', 'div', 'w7-pago',
        '<b>Cómo pagar con transferencia</b><ol>' +
        '<li>Agregá tus prendas al carrito.</li>' +
        '<li>En el carrito tocá «Pagar con Transferencia»: el 25% se descuenta solo.</li>' +
        `<li>Después de transferir, <a href="${esc(D.informe || '/pages/informe-de-transferencia')}">mandanos el comprobante</a>.</li></ol>`);
      const open = !p.isConnected;
      if (open) place(p, box); else p.remove();
      box.setAttribute('aria-expanded', String(open));
    };
    box.addEventListener('click', (e) => { if (!e.target.closest('a')) abrir(); });
    box.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); abrir(); } });
  }

  // 4 · Talle: título + link a la guía, «Tu talle en esta prenda», medidas de la modelo en 1 línea
  function talle() {
    const f = fs('talle');
    if (!f) return;
    const lbl = mk('w7-lbl-t', 'div', 'w7-lbl', '<span>Talle</span><button type="button">¿Cuál es mi talle? ›</button>');
    if (!lbl.dataset.on) { lbl.dataset.on = 1; lbl.querySelector('button').addEventListener('click', () => { const g = $('#gt-inline'); if (g) g.click(); }); }
    // «Tu talle en esta prenda: M» (solo si la persona cargó sus medidas en este navegador)
    const s = typeof window.w7TalleDe === 'function' ? window.w7TalleDe(D.handle) : null;
    const tt = mk('w7-tt', 'div', 'w7-tt');
    if (s) {
      setHtml(tt, `✓ <b>Tu talle en esta prenda: ${esc(s)}</b><br><span>Según las medidas que cargaste</span>`);
      place(tt, f, true);
      place(lbl, tt, true);
    } else {
      if (tt.isConnected) tt.remove();
      place(lbl, f, true);
    }
    // Medidas de la modelo en 1 línea (el bloque original se guarda: si el theme
    // vuelve a dibujar los talles, se lo vuelve a poner en su lugar)
    ACC = ACC || $('.gt-modelo-acc');
    const acc = ACC;
    const cards = acc ? $$('.dm-card', acc) : [];
    if (!acc || !cards.length) return;
    const abajo = D.abajo || /jogg|short|jean|bermuda|pollera|calza|pantal|legging|biker/i.test(txt($('product-info h1')));
    const vals = $$('input', f).map((i) => i.value);
    const partes = cards.map((c) => {
      const quien = txt($('.dm-card__name', c));
      const row = $$('.dm-row', c).find((r) => txt($('.dm-k', r)).toLowerCase() === (abajo ? 'talle abajo' : 'talle arriba'));
      if (!row) return null;
      let v = txt($('.dm-v', row));
      const [a, n] = v.split('/').map((x) => (x || '').trim());
      if (vals.includes(a)) v = a; else if (n && vals.includes(n)) v = n;
      return { mujer: /mujer/i.test(quien), v };
    }).filter(Boolean);
    if (!partes.length) return;
    const frase = partes.length === 1
      ? `${partes[0].mujer ? 'La modelo usa' : 'El modelo usa'} talle ${partes[0].v}`
      : 'Modelos: ' + partes.map((p) => `${p.mujer ? 'ella' : 'él'} ${p.v}`).join(' · ');
    const mod = mk('w7-mod', 'div', 'w7-mod');
    setHtml(mod, `${esc(frase)} · <button type="button" aria-expanded="${acc.classList.contains('w7-open')}">ver sus medidas</button>`);
    if (!mod.dataset.on) {
      mod.dataset.on = 1;
      mod.addEventListener('click', (e) => {
        if (!e.target.closest('button')) return;
        const a = ACC;
        const open = !a.classList.contains('w7-open');
        a.classList.toggle('w7-open', open);
        const d = $('details', a); if (d) d.open = open;
        e.target.setAttribute('aria-expanded', String(open));
      });
    }
    place(mod, f);
    place(acc, mod);
  }

  // 5a · Nombre debajo de cada color. El bloque «variantes_compactas» lo sacaba del atributo
  //      title de la etiqueta, que la 6.1 ya no trae: acá se toma del valor de la opción.
  function nombres() {
    $$('fieldset[data-option-slug="color"] ul.swatches label.color-swatch').forEach((l) => {
      if (l.parentElement.querySelector('.dlvr-cname')) return;
      const i = l.htmlFor && document.getElementById(l.htmlFor);
      const v = l.title || (i && i.value);
      if (!v) return;
      const s = document.createElement('span');
      s.className = 'dlvr-cname';
      s.textContent = v;
      l.parentElement.appendChild(s);
    });
  }

  // 5 · Título de color: «COLOR · NEGRO» + «44 colores» (todos los colores quedan a la vista)
  function color() {
    const f = fs('color');
    if (!f) return;
    const n = $$('ul.swatches > li', f).filter((li) => li.offsetParent !== null).length;
    const lbl = mk('w7-lbl-c', 'div', 'w7-lbl');
    setHtml(lbl, `<span>Color · ${esc(elegido(f))}</span>` + (n > 1 ? `<span class="g">${n} colores</span>` : ''));
    place(lbl, f, true);
  }

  // 6 · Envío en 1 línea debajo del botón (una sola promesa) + mismo texto en «Detalles»
  function envio() {
    const buy = $('product-info .product-form-wrapper');
    const l1 = txt($('.dlvr-llega-l1'));
    if (!buy || !l1) return;
    const m = txt($('.dlvr-envio-gratis')).match(/\$\s?[\d.]+/);
    const el = mk('w7-env', 'button', 'w7-env');
    setHtml(el, `🚚 <b>${esc(l1)}</b>` + (m ? ` · Envío gratis desde ${esc(m[0])}` : '') + ' · Cambios en 30 días');
    if (!el.dataset.on) {
      el.dataset.on = 1;
      el.addEventListener('click', () => {
        const it = $$('.pdp5-item').find((i) => /env[ií]os/i.test(txt($('.pdp5-trigger', i))));
        if (!it) return;
        if (!it.classList.contains('open')) $('.pdp5-trigger', it).click();
        it.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
    place(el, buy);
    // 26-oct (Alan): el calculador por código postal del theme («Ingresá tu CP») vuelve, debajo de la línea de envío
    const cl = document.getElementById('dlvr-cp-link'), cf = document.getElementById('dlvr-cp-form');
    if (cl && cf) {
      const cp = mk('w7-cpost', 'div', 'w7-cpost');
      if (cl.parentNode !== cp) cp.appendChild(cl);
      if (cf.parentNode !== cp) cp.appendChild(cf);
      place(cp, el);
      // 26-oct (Uri): sin CP guardado, el campo ya está a la vista (antes había que tocar «Ingresá tu CP» y la página saltaba)
      let saved = ''; try { saved = localStorage.getItem('dlvrCP') || ''; } catch (e) {}
      if (!saved && !cp.dataset.w7Abierto) {
        cp.dataset.w7Abierto = 1; cl.hidden = true; cf.hidden = false;
        const inp = cf.querySelector('input'); if (inp && !inp.placeholder.includes('postal')) inp.placeholder = 'Código postal';
        const ok = cf.querySelector('button'); if (ok) { ok.textContent = 'Calcular'; ok.addEventListener('click', () => { setTimeout(() => { if (cf.hidden) cl.hidden = false; }, 50); }); }
      }
    }
    // En «Detalles → Envíos» decía «48–72 hs hábiles»: se unifica con la línea de arriba
    // y con Preguntas frecuentes («despachamos en 24 a 48 hs hábiles»).
    const pd = $('.pdp5');
    if (!pd) return;
    const w = document.createTreeWalker(pd, NodeFilter.SHOW_TEXT);
    let nd;
    while ((nd = w.nextNode())) {
      const v = nd.nodeValue;
      if (/48\s*[–-]\s*72 hs hábiles · Todo el país/.test(v)) nd.nodeValue = v.replace(/48\s*[–-]\s*72 hs hábiles · Todo el país/, `${l1} · Todo el país`);
    }
    $$('.pdp5-row-text', pd).forEach((r) => {
      const st = $('strong', r);
      if (st && /^Despachamos de/.test(r.firstChild && r.firstChild.nodeValue || '') && /48 a 72 hs hábiles/.test(st.textContent)) {
        r.firstChild.nodeValue = 'Despachamos en ';
        st.textContent = '24 a 48 hs hábiles';
      }
    });
  }

  // 7 · Reseñas: nota + fotos + 3 reseñas + «Ver las 64»
  function resenas() {
    const lista = $('.tt-review-list');
    if (!lista) return;
    const sec = lista.closest('.shopify-section');
    if (sec && !sec.classList.contains('w7-rv')) sec.classList.add('w7-rv');
    const n = $$(':scope > .list-review', lista).length;
    const tot = (txt($('.tt-tabs-list')).match(/Reseñas\s*\((\d+)\)/) || [])[1];
    const btn = mk('w7-rv-mas', 'button', 'w7-rv-mas');
    if (n <= 3 && !(tot > 3)) { if (btn.isConnected) btn.remove(); return; }
    setTxt(btn, tot ? `Ver las ${tot} reseñas` : 'Ver más reseñas');
    if (!btn.dataset.on) { btn.dataset.on = 1; btn.addEventListener('click', () => { const s = $('.w7-rv'); if (s) s.classList.add('w7-rv-all'); }); }
    place(btn, lista);
  }

  // 8 · Botón Agregar fijo abajo, con talle, color y precio
  function fijo() {
    const real = $('product-info .buy-buttons [name="add"]');
    if (!real) return;
    let b = document.getElementById('w7-stk');
    if (!b) {
      b = document.createElement('div');
      b.id = 'w7-stk'; b.className = 'w7-stk';
      b.innerHTML = '<div class="q"><span></span><b></b></div><button type="button"></button>';
      b.querySelector('button').addEventListener('click', () => { const r = $('product-info .buy-buttons [name="add"]'); if (r && !r.disabled) r.click(); });
      document.body.appendChild(b);
      document.body.classList.add('w7-pdp-on');
    }
    const q = [elegido(fs('talle')), elegido(fs('color'))].filter(Boolean).join(' · ');
    setTxt(b.querySelector('.q span'), q);
    setTxt(b.querySelector('.q b'), txt($('#dlvrDiscPrice')));
    const bt = b.querySelector('button');
    setTxt(bt, txt($('.btn-text', real)) || 'Agregar al carrito');
    if (bt.disabled !== real.disabled) bt.disabled = real.disabled;
  }

  function decorate() {
    if (!$('product-info')) return;
    [plana, desc, galeria, social, precio, talle, nombres, color, envio, resenas].concat(mq.matches ? [fijo] : []).forEach((f) => { try { f(); } catch (e) { /* una parte que falla no frena las otras */ } });
  }

  const start = () => {
    decorate();
    if (mq.matches) { aire(); setTimeout(aire, 800); }
    let t;
    const later = () => { clearTimeout(t); t = setTimeout(decorate, 120); };
    new MutationObserver(later).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class'] });
    document.addEventListener('change', () => { later(); if (mq.matches) setTimeout(aire, 600); });
    // Al cambiar talle o color el theme reemplaza todo el bloque de variantes: se vuelve a decorar en el
    // mismo instante (antes de que se pinte la pantalla), así no desaparece el título ni salta el bloque.
    const info = $('product-info');
    if (info) new MutationObserver((ms) => {
      if (ms.some((m) => [...m.addedNodes].some((n) => n.nodeType === 1 && (n.matches('variant-picker') || n.querySelector && n.querySelector('variant-picker'))))) decorate();
    }).observe(info, { childList: true, subtree: true });
    document.addEventListener('w7:talle-listo', later);
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();
})();
